import type { MultipleChoiceQ } from "../../types/quiz";

export type MultipleChoiceProps = {
  q: MultipleChoiceQ;
  value?: number;
  onChange: (i: number) => void;
};

export function MultipleChoice({ q, value, onChange }: MultipleChoiceProps) {
  return (
      <div className="cq-grid cq-gap-4 md:cq-grid-cols-2">
        {q.options.map((o, i) => {
          const checked = value === i;
          return (
              <label
                  key={i}
                  className={[
                    "cq-flex cq-items-center cq-gap-3 cq-p-3 sm:cq-p-4 cq-flex-1 cq-self-stretch cq-cursor-pointer",
                    "!cq-border-2 cq-text-black !cq-border-cfa-blue-500 !cq-border-solid",
                    "has-[:checked]:!cq-bg-black has-[:checked]:!cq-border-black has-[:checked]:!cq-text-white",
                  ].join(" ")}
              >
                <input
                    type="radio"
                    name={`q-${q.id}`}
                    checked={checked}
                    onChange={() => onChange(i)}
                    className="cq-w-6 cq-h-6 cq-shrink-0"
                />
                <div className="cq-text-sm md:cq-text-lg md:cq-leading-6">
                  {o.text}
                </div>
              </label>
          );
        })}
      </div>
  );
}

export default MultipleChoice;
